import { useEffect, useState } from "react";

export const USER_DATA_CHANGED_EVENT = "userDataChanged";

export function readStoredUserData() {
  try {
    return JSON.parse(window.localStorage.getItem("userData") || "null");
  } catch (_error) {
    return null;
  }
}

export function mergeCurrentUserData(storedUser, currentUser) {
  return {
    ...(storedUser || {}),
    ...(currentUser || {}),
  };
}

export function writeStoredUserData(userData) {
  if (userData) {
    window.localStorage.setItem("userData", JSON.stringify(userData));
    if (userData.exam_access === 'ielts' || userData.exam_access === 'pte') {
      window.localStorage.setItem('exam-type', userData.exam_access);
      window.dispatchEvent(new CustomEvent('examTypeChanged', { detail: { examType: userData.exam_access } }));
    }
  } else {
    window.localStorage.removeItem("userData");
  }
  window.dispatchEvent(new Event(USER_DATA_CHANGED_EVENT));
}

export function useStoredUserData() {
  const [userData, setUserData] = useState(() => readStoredUserData());

  useEffect(() => {
    const refresh = () => setUserData(readStoredUserData());
    const handleStorage = (event) => {
      if (!event || event.key === "userData") refresh();
    };

    window.addEventListener(USER_DATA_CHANGED_EVENT, refresh);
    window.addEventListener("storage", handleStorage);
    return () => {
      window.removeEventListener(USER_DATA_CHANGED_EVENT, refresh);
      window.removeEventListener("storage", handleStorage);
    };
  }, []);

  return userData;
}
